import { LoadingFallback } from '@/components/LoadingFallback'
import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'

const Landing = lazy(() => import('@/pages/Landing/Landing'))
const Dashboard = lazy(() => import('@/pages/Dashboard/Dashboard'))
const SsrsReports = lazy(() => import('@/pages/Analytics/SsrsReports'))
const AdvancedReports = lazy(() => import('@/pages/Analytics/AdvancedReports'))
const Pay = lazy(() => import('@/pages/Invoices/Pay'))
const Invoices = lazy(() => import('@/pages/Invoices/Invoices'))
const Sites = lazy(() => import('@/pages/Sites/Sites'))
const OnCall = lazy(() => import('@/pages/Sites/OnCall'))
const Sensors = lazy(() => import('@/pages/Sensors/Sensors'))
const Settings = lazy(() => import('@/pages/Settings/Settings'))
const EnhancedSupport = lazy(() => import('@/pages/Support/EnhancedSupport'))
const Documents = lazy(() => import('@/pages/Documents/Documents'))
const LegalDocument = lazy(() => import('@/components/LegalDocument'))
const AccessDenied = lazy(() => import('@/components/AccessDenied'))
const Forbidden = lazy(() => import('@/components/Forbidden'))
const NotFound = lazy(() => import('@/components/NotFound'))

const Routing = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <Landing />
          </Suspense>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Dashboard />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route path="/analytics">
        <Route
          path="ssrs-report/:reportCategory"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SsrsReports />
            </Suspense>
          }
        />
        <Route
          path="advanced-report/:reportId"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <AdvancedReports />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="/invoices"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Invoices />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sites/all"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Sites />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sites/:siteId"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Sites />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sites/on-call"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OnCall />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sensors"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Sensors />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Settings />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <EnhancedSupport />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/guest-invoice-pmt"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <Pay />
          </Suspense>
        }
      />
      <Route
        path="/terms-and-conditions"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <LegalDocument type="terms" />
          </Suspense>
        }
      />

      <Route
        path="/legal/terms-and-conditions"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <LegalDocument type="termsAndConditions" />
          </Suspense>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <LegalDocument type="privacy" />
          </Suspense>
        }
      />
      <Route
        path="/documents"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Documents />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/401"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <AccessDenied />
          </Suspense>
        }
      />
      <Route
        path="/403"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <Forbidden />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <NotFound />
          </Suspense>
        }
      />
    </Routes>
  )
}

export default Routing
